import { gql } from "apollo-boost"

export const SUBMISSION_TECHNICAL_SPECIFICATIONS = gql`
    query SubmissionTechnicalSpecification($id: ID!) {
        SubmissionTechnicalSpecification(id: $id) {
            id
            name
            startDate
            endDate
            developmentObjective
            generalObjective
            communicationObjective
            state
            status
            specificObjectives {
                id
                orderIndex
                description
                indicators {
                    id
                    isBlocking
                    type
                    title
                    orderIndex
                    description
                    methodology
                    formula
                    meansOfVerification
                    orderIndex
                    baseline
                    goal
                    startDate
                    endDate
                    measurementPeriodicity
                    products
                    metodologyDocuments {
                        id
                        name
                        url
                    }
                }
                activities {
                    id
                    isBlocking
                    title
                    orderIndex
                    description
                    responsible
                    methodology
                    formula
                    meansOfVerification
                    baseline
                    goal
                    place
                    months
                    inputs
                    products
                    metodologyDocuments {
                        id
                        name
                        url
                    }
                }
            }
            developmentObjectiveIndicators {
                id
                isBlocking
                type
                title
                description
                methodology
                formula
                meansOfVerification
                baseline
                goal
                startDate
                orderIndex
                endDate
                measurementPeriodicity
                products
                metodologyDocuments {
                    id
                    name
                    url
                }
            }
            generalObjectiveIndicators {
                id
                isBlocking
                type
                title
                description
                methodology
                orderIndex
                formula
                meansOfVerification
                baseline
                goal
                startDate
                endDate
                measurementPeriodicity
                products
                metodologyDocuments {
                    id
                    name
                    url
                }
            }
            communicationObjectiveActivity {
                id
                isBlocking
                title
                orderIndex
                description
                responsible
                methodology
                formula
                meansOfVerification
                baseline
                goal
                place
                months
                inputs
                products
                metodologyDocuments {
                id
                name
                url
                }
            }     
        }
    }
`

export const ACTIVITIES_SPECIFIC_OBJECTIVES = gql`
    query activitiesSpecificObjectives($id: ID!) {
        activitiesSpecificObjectives(id: $id) {
            specificObjectives {
                id
                orderIndex
                description
                activities {
                    id
                    isBlocking
                    title
                    orderIndex
                    description
                    responsible
                    methodology
                    formula
                    meansOfVerification
                    baseline
                    goal
                    place
                    months
                    inputs
                    products
                }
            }
        }
    }
`
